module.exports = __webpack_public_path__ + "img/gnu_smart_gallery1.d09e051a.jpg";